// extracted by mini-css-extract-plugin
module.exports = {"switch":"style_switch__187jx","status":"style_status__3w_N2","control":"style_control__2dPb5"};